import { PureComponent } from 'react';
import strings from '../Globalization';

class PrintProperties extends PureComponent {
	constructor(props) {
		super(props);
		Object.assign(this, {
			TopSection: [
				{ DataProperty: 'CycleName', HeaderLabel: strings.Cycle, isWasher: false },
				{ DataProperty: 'CycleStart', HeaderLabel: strings.StartDate, isDate: true, isWasher: false },
				{ DataProperty: 'BILotNumber', HeaderLabel: strings.BILotNumber, isParametric: false, isWasher: false },
				{ DataProperty: 'BIResultIcon', HeaderLabel: strings.BIResult, isParametric: false, isWasher: false },
				{ DataProperty: 'CILotNumber', HeaderLabel: strings.CILotNumber, isParametric: false, isWasher: false },
				{ DataProperty: 'CIResultIcon', HeaderLabel: strings.CIResult, isParametric: false, isWasher: false },
				{ DataProperty: 'ReviewedBy', HeaderLabel: strings.ApprovedBy, isParametric: true, isAccess: true },
				{
					DataProperty: 'ReviewedDate',
					HeaderLabel: strings.ApprovedOn,
					isDate: true,
					isParametric: true,
					isAccess: true,
					isLocal: true
				},
				{ DataProperty: 'ReviewStatus', HeaderLabel: strings.ReviewStatus, isParametric: true, isAccess: true },
				{ DataProperty: 'ReviewComment', HeaderLabel: strings.Comment, isParametric: true, isAccess: true },
				{ DataProperty: 'CycleStatusId', HeaderLabel: strings.SterCycleStatus },
				{ DataProperty: 'MonitoringStatus', HeaderLabel: strings.ProcessMonitoring, isParametric: true },
				{ DataProperty: 'ErrorDescription', HeaderLabel: strings.ErrorDescription }
			],
			LCSTopSection: [
				'CycleCount',
				'CycleStart',
				'CycleStatus',
				'CycleName',
				'CycleEnd',
				'ErrorDescription',
				'ChamberOpenedTime',
				'OperatorName',
				'CycleDuration',
				'UnloadOperatorName',
				'DeviceID',
				'PhysicianName',
				'CaseName',
				'ProcedureName',
				'ReviewStatus',
				'ReviewedBy',
				'ReviewTimeStamp',
				'ReviewComment',
				'MonitoringStatus',
				'STSLotNumber',
				'STSResultIcon',
				'LCSCILotNumber',
				'LCSCIResultIcon',
				'LocationName'
			],
			DiagnosticTopSection: [
				'CycleCount',
				'CycleStart',
				'CycleStatus',
				'CycleName',
				'CycleComplete',
				'OperatorName',
				'ErrorDescription',
				'ChamberOpenedTime',
				'CycleDuration',
				'UnloadOperatorName',
				'ReviewStatus',
				'ReviewedBy',
				'ReviewTimeStamp',
				'ReviewComment',
				'MonitoringStatus',
				'STSLotNumber',
				'STSResultIcon',
				'LCSCILotNumber',
				'LCSCIResultIcon',
				'LocationName'
			],
			EndoTopSection: [
				{ Name: 'LocationName', DataProperty: 'LocationName', HeaderLabel: strings.LocationName, isEquipment: true },
				{ Name: 'DeviceType', DataProperty: 'DeviceType', HeaderLabel: strings.DeviceType, isEquipment: true },
				{
					Name: 'EquipmentName',
					DataProperty: 'EquipmentName',
					HeaderLabel: strings.EquipmentId,
					isEquipment: true
				},
				{ Name: 'ModelName', DataProperty: 'ModelName', HeaderLabel: strings.EquipmentModel, isEquipment: true },
				{ Name: 'SerialNumber', DataProperty: 'SerialNumber', HeaderLabel: strings.SerialNumber, isEquipment: true },
				{ Name: 'CycleCount', DataProperty: 'CycleCount', HeaderLabel: strings.CycleCount, isCycle: true },
				{
					Name: 'CycleStart',
					DataProperty: 'CycleStart',
					HeaderLabel: strings.TimeDate,
					isCycle: true,
					isDate: true
				},
				{ Name: 'CycleStatus', DataProperty: 'CycleStatus', HeaderLabel: strings.CycleStatus, isCycle: true },
				{ Name: 'CycleName', DataProperty: 'CycleName', HeaderLabel: strings.CycleName, isCycle: true },
				{
					Name: 'CycleComplete',
					DataProperty: 'CycleEnd',
					HeaderLabel: strings.CycleComplete,
					isCycle: true,
					isDate: true
				},
				{ Name: 'OperatorName', DataProperty: 'OperatorName', HeaderLabel: strings.OperatorName, isCycle: true },
				{ Name: 'OperatorName', DataProperty: 'OperatorName', HeaderLabel: strings.LoadOperator, isCycle: true },
				{
					Name: 'UnloadOperatorName',
					DataProperty: 'UnloadOperatorName',
					HeaderLabel: strings.UnloadOperator,
					isCycle: true
				},
				{
					Name: 'ChamberOpenedTime',
					DataProperty: 'ChamberOpenedTime',
					HeaderLabel: strings.ChamberOpened,
					isCycle: true,
					isDate: true
				},
				{ Name: 'CycleDuration', DataProperty: 'CycleDuration', HeaderLabel: strings.CycleDuration, isCycle: true },
				{
					Name: 'ErrorDescription',
					DataProperty: 'ErrorDescription',
					HeaderLabel: strings.AlarmDescription,
					isCycle: true
				},
				{ Name: 'EndoScopeTop', HeaderLabel: strings.EndoScopeTop, index: 3 },
				{
					Name: 'EndoscopeSerialNumberTop',
					DataProperty: 'EndoscopeSerialNumberTop',
					HeaderLabel: strings.SNo,
					isEndoScopeTop: true,
					index: 0,
					isEnspire: false
				},
				{
					Name: 'EndoscopeTopName',
					DataProperty: 'EndoscopeTopName',
					HeaderLabel: strings.EndoName,
					isEndoScopeTop: true,
					index: 0,
					isEnspire: false
				},
				{
					Name: 'EndoscopeModelTop',
					DataProperty: 'EndoscopeModelTop',
					HeaderLabel: strings.EndoModel,
					isEndoScopeTop: true,
					index: 0,
					isEnspire: false
				},
				{
					Name: 'TopOrderNumber',
					DataProperty: 'ItemRefNumberTop',
					HeaderLabel: strings.EndoON,
					isEndoScopeTop: true,
					valueRequired: true,
					index: 0,
					isEnspire: false
				},
				{
					Name: 'EndoscopeSerialNumberTop',
					DataProperty: 'EndoscopeSerialNumberTop',
					HeaderLabel: strings.SNo,
					isEndoScopeTop: true,
					index: 1,
					isEnspire: false
				},
				{
					Name: 'EndoscopeTopName',
					DataProperty: 'EndoscopeTopName',
					HeaderLabel: strings.EndoName,
					isEndoScopeTop: true,
					index: 1,
					isEnspire: false
				},
				{
					Name: 'EndoscopeModelTop',
					DataProperty: 'EndoscopeModelTop',
					HeaderLabel: strings.EndoModel,
					isEndoScopeTop: true,
					index: 1,
					isEnspire: false
				},
				{
					Name: 'TopOrderNumber',
					DataProperty: 'ItemRefNumberTop',
					HeaderLabel: strings.EndoON,
					isEndoScopeTop: true,
					valueRequired: true,
					index: 1,
					isEnspire: false
				},
				{
					Name: 'EndoscopeSerialNumberTop',
					DataProperty: 'EndoscopeSerialNumberTop',
					HeaderLabel: strings.SNo,
					isEndoScopeTop: true,
					index: 2,
					isEnspire: false
				},
				{
					Name: 'EndoscopeTopName',
					DataProperty: 'EndoscopeTopName',
					HeaderLabel: strings.EndoName,
					isEndoScopeTop: true,
					index: 2,
					isEnspire: false
				},
				{
					Name: 'EndoscopeModelTop',
					DataProperty: 'EndoscopeModelTop',
					HeaderLabel: strings.EndoModel,
					isEndoScopeTop: true,
					index: 2,
					isEnspire: false
				},
				{
					Name: 'TopOrderNumber',
					DataProperty: 'ItemRefNumberTop',
					HeaderLabel: strings.EndoON,
					isEndoScopeTop: true,
					valueRequired: true,
					index: 2,
					isEnspire: false
				},
				{ Name: 'EndoScopeBottom', HeaderLabel: strings.EndoScopeBottom, index: 3 },
				{
					Name: 'EndoscopeSerialNumberBottom',
					DataProperty: 'EndoscopeSerialNumberBottom',
					HeaderLabel: strings.SNo,
					isEndoScopeBottom: true,
					index: 0,
					isEnspire: false
				},
				{
					Name: 'EndoscopeBottomName',
					DataProperty: 'EndoscopeBottomName',
					HeaderLabel: strings.EndoName,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 0,
					isEnspire: false
				},
				{
					Name: 'EndoscopeModelBottom',
					DataProperty: 'EndoscopeModelBottom',
					HeaderLabel: strings.EndoModel,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 0,
					isEnspire: false
				},
				{
					Name: 'BottomOrderNumber',
					DataProperty: 'ItemRefNumberBottom',
					HeaderLabel: strings.EndoON,
					isAccess: true,
					isEndoScopeBottom: true,
					valueRequired: true,
					index: 0,
					isEnspire: false
				},
				{
					Name: 'EndoscopeSerialNumberBottom',
					DataProperty: 'EndoscopeSerialNumberBottom',
					HeaderLabel: strings.SNo,
					isEndoScopeBottom: true,
					index: 1,
					isEnspire: false
				},
				{
					Name: 'EndoscopeBottomName',
					DataProperty: 'EndoscopeBottomName',
					HeaderLabel: strings.EndoName,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 1,
					isEnspire: false
				},
				{
					Name: 'EndoscopeModelBottom',
					DataProperty: 'EndoscopeModelBottom',
					HeaderLabel: strings.EndoModel,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 1,
					isEnspire: false
				},
				{
					Name: 'BottomOrderNumber',
					DataProperty: 'ItemRefNumberBottom',
					HeaderLabel: strings.EndoON,
					isAccess: true,
					isEndoScopeBottom: true,
					valueRequired: true,
					index: 1,
					isEnspire: false
				},
				{
					Name: 'EndoscopeSerialNumberBottom',
					DataProperty: 'EndoscopeSerialNumberBottom',
					HeaderLabel: strings.SNo,
					isEndoScopeBottom: true,
					index: 2,
					isEnspire: false
				},
				{
					Name: 'EndoscopeBottomName',
					DataProperty: 'EndoscopeBottomName',
					HeaderLabel: strings.EndoName,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 2,
					isEnspire: false
				},
				{
					Name: 'EndoscopeModelBottom',
					DataProperty: 'EndoscopeModelBottom',
					HeaderLabel: strings.EndoModel,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 2,
					isEnspire: false
				},
				{
					Name: 'BottomOrderNumber',
					DataProperty: 'ItemRefNumberBottom',
					HeaderLabel: strings.EndoON,
					isAccess: true,
					isEndoScopeBottom: true,
					valueRequired: true,
					index: 2,
					isEnspire: false
				},
				{ Name: 'InstrumentNumber', DataProperty: 'InstrumentNumber', HeaderLabel: '', isEnspire: true },
				{ Name: 'InstrumentSN', DataProperty: 'InstrumentSN', HeaderLabel: strings.DeviceSerial, isEnspire: true },
				{ Name: 'InstrumentName', DataProperty: 'InstrumentName', HeaderLabel: strings.DeviceId, isEnspire: true },
				{ Name: 'ModelNumber', DataProperty: 'ModelNumber', HeaderLabel: strings.DeviceModel, isEnspire: true },
				{ Name: 'CaseID', DataProperty: 'CaseID', HeaderLabel: strings.CaseId, isEnspire: true },
				{ Name: 'ProcedureID', DataProperty: 'ProcedureID', HeaderLabel: strings.ProcedureId, isEnspire: true },
				{ Name: 'PhysicianID', DataProperty: 'PhysicianID', HeaderLabel: strings.Physician, isEnspire: true },
				{ Name: 'ReviewStatus', DataProperty: 'ReviewStatus', HeaderLabel: strings.ReviewStatus, isReview: true },
				{ Name: 'ReviewedBy', DataProperty: 'ReviewedBy', HeaderLabel: strings.ApprovedBy, isReview: true },
				{
					Name: 'ReviewTimeStamp',
					DataProperty: 'ReviewTimeStamp',
					HeaderLabel: strings.ApprovedOn,
					isReview: true,
					isDate: true,
					isLocal: true
				},
				{ Name: 'ReviewComment', DataProperty: 'Comment', HeaderLabel: strings.Comment, isReview: true },
				{ Name: 'DeviceID', DataProperty: 'DeviceID', HeaderLabel: strings.DeviceId, isLCS: true },
				{ Name: 'PhysicianName', DataProperty: 'PhysicianName', HeaderLabel: strings.Physician, isLCS: true },
				{ Name: 'CaseName', DataProperty: 'CaseName', HeaderLabel: strings.CaseId, isLCS: true },
				{ Name: 'ProcedureName', DataProperty: 'ProcedureName', HeaderLabel: strings.ProcedureId, isLCS: true },

				{ Name: 'STSLotNumber', DataProperty: 'STSLotNumber', HeaderLabel: strings.STSLotNumber, isReview: true },
				{
					Name: 'STSResultIcon',
					DataProperty: 'STSResultIcon',
					HeaderLabel: strings.STSResult,
					isReview: true,
					isCustomRendering: true
				},
				{
					Name: 'MonitoringStatus',
					DataProperty: 'MonitoringStatus',
					HeaderLabel: strings.ProcessMonitoring,
					isReview: true
				},
				{ Name: 'LCSCILotNumber', DataProperty: 'LCSCILotNumber', HeaderLabel: strings.CILotNumber, isReview: true },
				{
					Name: 'LCSCIResultIcon',
					DataProperty: 'LCSCIResultIcon',
					HeaderLabel: strings.CIResult,
					isReview: true,
					isCustomRendering: true
				}
			],
			WasherCriticalParameter: [],
			WasherFlowCheck: [],
			Diagnostic: ['MaxlifeFilterTest', 'SystemDiagnosticTests'],
			LCSSystem: ['InletTemperature', 'Concentration', 'ExposureTemperature', 'FilTime', 'ExposureTime'],
			NONSterisTopSection: [
				{ DataProperty: 'CycleName', HeaderLabel: strings.CycleName, isCycle: true },
				{ DataProperty: 'CycleCount', HeaderLabel: strings.CycleCount, isCycle: true },
				{ DataProperty: 'BILotNumber', HeaderLabel: strings.BILotNumber, isParametric: false, isWasher: false },
				{ DataProperty: 'BIResultIcon', HeaderLabel: strings.BIResult, isParametric: false, isWasher: false },
				{ DataProperty: 'CILotNumber', HeaderLabel: strings.CILotNumber, isParametric: false, isWasher: false },
				{ DataProperty: 'CIResultIcon', HeaderLabel: strings.CIResult, isParametric: false, isWasher: false },
				{ DataProperty: 'ReviewedBy', HeaderLabel: strings.ApprovedBy, isReview: true },
				{
					DataProperty: 'ReviewedDate',
					HeaderLabel: strings.ApprovedOn,
					isReview: true,
					isDate: true,
					isLocal: true
				},
				{ DataProperty: 'ReviewStatus', HeaderLabel: strings.ReviewStatus, isReview: true },
				{ DataProperty: 'ReviewComment', HeaderLabel: strings.Comment, isReview: true }
			],
			RelianceCabinetTopSection: [
				{ DataProperty: 'CycleName', HeaderLabel: strings.EventName, isReliance: true, isCabinet: true },
				{
					DataProperty: 'CycleStart',
					HeaderLabel: strings.CycleDateTime,
					isDate: true,
					isReliance: true,
					isCabinet: true
				},
				{
					DataProperty: 'ErrorDescription',
					HeaderLabel: strings.AlarmDescription,
					isReliance: true,
					isCabinet: true
				},
				{ DataProperty: 'Label', HeaderLabel: strings.Label, isReliance: true, isCabinet: true },
				{ DataProperty: 'InstrumentName', HeaderLabel: strings.Endoscope, isReliance: true, isCabinet: true },
				{ DataProperty: 'InstrumentSN', HeaderLabel: strings.EndoscopeId, isReliance: true, isCabinet: true },
				{ DataProperty: 'ModelNumber', HeaderLabel: strings.EndoscopeType, isReliance: true, isCabinet: true },
				{ DataProperty: 'OperatorName', HeaderLabel: strings.OperatorName, isReliance: true, isCabinet: true },
				{ DataProperty: 'OperatorID', HeaderLabel: strings.OperatorId, isReliance: true, isCabinet: true },
				{
					DataProperty: 'UnloadOperatorName',
					HeaderLabel: strings.UnloadOperatorName,
					isReliance: false,
					isCabinet: true
				},
				{
					DataProperty: 'UnloadOperatorID',
					HeaderLabel: strings.UnloadOperatorID,
					isReliance: false,
					isCabinet: true
				}
			],
			EndoCabinetTopSection: [
				{ DataProperty: 'CycleName', HeaderLabel: strings.EventName, isEndo: true, isCabinet: true },
				{
					DataProperty: 'CycleStart',
					HeaderLabel: strings.CycleDateTime,
					isDate: true,
					isEndo: true,
					isCabinet: true
				},
				{
					DataProperty: 'ErrorDescription',
					HeaderLabel: strings.AlarmDescription,
					isEndo: true,
					isCabinet: true
				},
				{ DataProperty: 'Label', HeaderLabel: strings.Label, isEndo: true, isCabinet: true },
				{ DataProperty: 'InstrumentName', HeaderLabel: strings.Endoscope, isEndo: true, isCabinet: true },
				{ DataProperty: 'InstrumentSN', HeaderLabel: strings.EndoscopeId, isEndo: true, isCabinet: true },
				{ DataProperty: 'ModelNumber', HeaderLabel: strings.EndoscopeType, isEndo: true, isCabinet: false },
				{ DataProperty: 'OperatorName', HeaderLabel: strings.OperatorName, isEndo: true, isCabinet: true },
				{ DataProperty: 'OperatorID', HeaderLabel: strings.OperatorId, isEndo: true, isCabinet: true },
				{
					DataProperty: 'UnloadOperatorName',
					HeaderLabel: strings.UnloadOperatorName,
					isEndo: true,
					isCabinet: true
				},
				{
					DataProperty: 'UnloadOperatorID',
					HeaderLabel: strings.UnloadOperatorID,
					isEndo: true,
					isCabinet: true
				},
				{
					DataProperty: 'From',
					HeaderLabel: strings.From,
					extandedTags:true
				},
				{
					DataProperty: 'To',
					HeaderLabel: strings.To,
					extandedTags:true
				}
			],
			ISAANDRAERTopSection: [
				{
					DataProperty: 'CycleCount',
					HeaderLabel: strings.CycleCount,
					group: 'cycle'
				},
				{
					DataProperty: 'CycleStart',
					HeaderLabel: strings.CycleTimeDate,
					group: 'cycle',
					isDate: true
				},
				{
					DataProperty: 'CycleStatus',
					HeaderLabel: strings.CycleStatusSecond,
					group: 'cycle'
				},
				{
					DataProperty: 'CycleName',
					HeaderLabel: strings.CycleName,
					group: 'cycle'
				},
				{
					DataProperty: 'Basin',
					HeaderLabel: strings.Basin,
					group: 'cycle'
				},
				{
					DataProperty: 'EndoscopeID',
					HeaderLabel: strings.EndoscopeID,
					group: 'endoScope',
					type: 'label',
					dependsOn: 'EndoscopeSerialNumber'
				},
				{
					DataProperty: 'Type',
					HeaderLabel: strings.Type,
					group: 'endoScope',
					type: 'label',
					dependsOn: 'EndoscopeSerialNumber'
				},
				{
					DataProperty: 'Barcode',
					HeaderLabel: strings.Barcode,
					group: 'endoScope',
					type: 'label',
					dependsOn: 'EndoscopeSerialNumber'
				},
				{
					DataProperty: 'EndoscopeSerialNumber',
					HeaderLabel: strings.SerialNumberSecond,
					group: 'endoScope',
					type: 'label',
					dependsOn: 'EndoscopeSerialNumber'
				},
				{
					DataProperty: 'LoadOperatorName',
					HeaderLabel: strings.LoadOperator,
					group: 'load'
				},
				{
					DataProperty: 'UnLoadOperatorName',
					HeaderLabel: strings.UnloadOperator,
					group: 'load'
				},
				{
					DataProperty: 'PhysicianID',
					HeaderLabel: strings.PhysicianId,
					group: 'physician',
					dependsOn: 'EndoscopeSerialNumber'
				},
				{
					DataProperty: 'ReviewStatus',
					HeaderLabel: strings.ReviewStatus,
					group: 'review'
				},
				{
					DataProperty: 'ReviewedBy',
					HeaderLabel: strings.ReviewedBy,
					group: 'review'
				},
				{
					DataProperty: 'ReviewTimeStamp',
					HeaderLabel: strings.ApprovedOn,
					group: 'review',
					isDate: true,
					isLocal: true
				},
				{
					DataProperty: 'Comment',
					HeaderLabel: strings.Comment,
					group: 'review'
				},
				{
					DataProperty: 'MonitoringStatus',
					HeaderLabel: strings.ProcessMonitoring,
					group: 'review',
					lgOffset: 4
				},
				{
					DataProperty: 'ErrorDescription',
					HeaderLabel: strings.AlarmDescription,
					group: 'review'
				}
			],
			System1EndoTopSection: [
				{
					Name: "LocationName",
					DataProperty: "LocationName",
					HeaderLabel: strings.LocationName,
					isEquipment: true,
				},
				{
					Name: "DeviceType",
					DataProperty: "DeviceType",
					HeaderLabel: strings.DeviceType,
					isEquipment: true,
				},
				{
					Name: "EquipmentName",
					DataProperty: "EquipmentName",
					HeaderLabel: strings.EquipmentId,
					isEquipment: true,
				},
				{
					Name: "ModelName",
					DataProperty: "ModelName",
					HeaderLabel: strings.EquipmentModel,
					isEquipment: true,
				},
				{
					Name: "SerialNumber",
					DataProperty: "SerialNumber",
					HeaderLabel: strings.SerialNumber,
					isEquipment: true,
				},
				{
					Name: "CycleCount",
					DataProperty: "CycleCount",
					HeaderLabel: strings.CycleCount,
					isCycle: true,
				},
				{
					Name: "CycleStart",
					DataProperty: "CycleStart",
					HeaderLabel: strings.TimeDate,
					isCycle: true,
					isDate: true,
				},
				{
					Name: "CycleStatus",
					DataProperty: "CycleStatus",
					HeaderLabel: strings.CycleStatus,
					isCycle: true,
				},
				{
					Name: "CycleName",
					DataProperty: "CycleName",
					HeaderLabel: strings.CycleName,
					isCycle: true,
				},
				{
					Name: "CycleComplete",
					DataProperty: "CycleEnd",
					HeaderLabel: strings.CycleComplete,
					isCycle: true,
					isDate: true,
				},
				{
					Name: "MaxLifeFilterTest",
					DataProperty: "FilterTestStatus",
					HeaderLabel: strings.MaxLifeFilterTest,
					isCycle: true,
				},
				{
					Name: "OperatorName",
					DataProperty: "OperatorName",
					HeaderLabel: strings.LoadOperator,
					isCycle: true,
				},
				{
					Name: "UnloadOperatorName",
					DataProperty: "UnloadOperatorName",
					HeaderLabel: strings.UnloadOperator,
					isCycle: true,
				},
				{
					Name: "ChamberOpenedTime",
					DataProperty: "ChamberOpenedTime",
					HeaderLabel: strings.ChamberOpened,
					isCycle: true,
					isDate: true,
				},
				{
					Name: "CycleDuration",
					DataProperty: "CycleDuration",
					HeaderLabel: strings.CycleDuration,
					isCycle: true,
				},
				{
					Name: "ErrorDescription",
					DataProperty: "ErrorDescription",
					HeaderLabel: strings.AlarmDescription,
					isCycle: true,
				},
				{
					Name: "EndoScopeTop",
					HeaderLabel: strings.EndoScopeTop,
					index: 3,
				},
				{
					Name: "EndoscopeSerialNumberTop",
					DataProperty: "EndoscopeSerialNumberTop",
					HeaderLabel: strings.SNo,
					isEndoScopeTop: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeTopName",
					DataProperty: "EndoscopeTopName",
					HeaderLabel: strings.EndoName,
					isEndoScopeTop: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelTop",
					DataProperty: "EndoscopeModelTop",
					HeaderLabel: strings.EndoModel,
					isEndoScopeTop: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "TopOrderNumber",
					DataProperty: "ItemRefNumberTop",
					HeaderLabel: strings.EndoON,
					isEndoScopeTop: true,
					valueRequired: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeSerialNumberTop",
					DataProperty: "EndoscopeSerialNumberTop",
					HeaderLabel: strings.SNo,
					isEndoScopeTop: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeTopName",
					DataProperty: "EndoscopeTopName",
					HeaderLabel: strings.EndoName,
					isEndoScopeTop: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelTop",
					DataProperty: "EndoscopeModelTop",
					HeaderLabel: strings.EndoModel,
					isEndoScopeTop: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "TopOrderNumber",
					DataProperty: "ItemRefNumberTop",
					HeaderLabel: strings.EndoON,
					isEndoScopeTop: true,
					valueRequired: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeSerialNumberTop",
					DataProperty: "EndoscopeSerialNumberTop",
					HeaderLabel: strings.SNo,
					isEndoScopeTop: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "EndoscopeTopName",
					DataProperty: "EndoscopeTopName",
					HeaderLabel: strings.EndoName,
					isEndoScopeTop: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelTop",
					DataProperty: "EndoscopeModelTop",
					HeaderLabel: strings.EndoModel,
					isEndoScopeTop: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "TopOrderNumber",
					DataProperty: "ItemRefNumberTop",
					HeaderLabel: strings.EndoON,
					isEndoScopeTop: true,
					valueRequired: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "EndoScopeBottom",
					HeaderLabel: strings.EndoScopeBottom,
					index: 3,
				},
				{
					Name: "EndoscopeSerialNumberBottom",
					DataProperty: "EndoscopeSerialNumberBottom",
					HeaderLabel: strings.SNo,
					isEndoScopeBottom: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeBottomName",
					DataProperty: "EndoscopeBottomName",
					HeaderLabel: strings.EndoName,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelBottom",
					DataProperty: "EndoscopeModelBottom",
					HeaderLabel: strings.EndoModel,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "BottomOrderNumber",
					DataProperty: "ItemRefNumberBottom",
					HeaderLabel: strings.EndoON,
					isAccess: true,
					isEndoScopeBottom: true,
					valueRequired: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeSerialNumberBottom",
					DataProperty: "EndoscopeSerialNumberBottom",
					HeaderLabel: strings.SNo,
					isEndoScopeBottom: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeBottomName",
					DataProperty: "EndoscopeBottomName",
					HeaderLabel: strings.EndoName,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelBottom",
					DataProperty: "EndoscopeModelBottom",
					HeaderLabel: strings.EndoModel,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "BottomOrderNumber",
					DataProperty: "ItemRefNumberBottom",
					HeaderLabel: strings.EndoON,
					isAccess: true,
					isEndoScopeBottom: true,
					valueRequired: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeSerialNumberBottom",
					DataProperty: "EndoscopeSerialNumberBottom",
					HeaderLabel: strings.SNo,
					isEndoScopeBottom: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "EndoscopeBottomName",
					DataProperty: "EndoscopeBottomName",
					HeaderLabel: strings.EndoName,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelBottom",
					DataProperty: "EndoscopeModelBottom",
					HeaderLabel: strings.EndoModel,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "BottomOrderNumber",
					DataProperty: "ItemRefNumberBottom",
					HeaderLabel: strings.EndoON,
					isAccess: true,
					isEndoScopeBottom: true,
					valueRequired: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "InstrumentNumber",
					DataProperty: "InstrumentNumber",
					HeaderLabel: "",
					isEnspire: true,
				},
				{
					Name: "InstrumentSN",
					DataProperty: "InstrumentSN",
					HeaderLabel: strings.DeviceSerial,
					isEnspire: true,
				},
				{
					Name: "InstrumentName",
					DataProperty: "InstrumentName",
					HeaderLabel: strings.DeviceId,
					isEnspire: true,
				},
				{
					Name: "ModelNumber",
					DataProperty: "ModelNumber",
					HeaderLabel: strings.DeviceModel,
					isEnspire: true,
				},
				{
					Name: "CaseID",
					DataProperty: "CaseID",
					HeaderLabel: strings.CaseId,
					isEnspire: true,
				},
				{
					Name: "ProcedureID",
					DataProperty: "ProcedureID",
					HeaderLabel: strings.ProcedureId,
					isEnspire: true,
				},
				{
					Name: "PhysicianID",
					DataProperty: "PhysicianID",
					HeaderLabel: strings.Physician,
					isEnspire: true,
				},
				{
					Name: "ReviewStatus",
					DataProperty: "ReviewStatus",
					HeaderLabel: strings.ReviewStatus,
					isReview: true,
				},
				{
					Name: "ReviewedBy",
					DataProperty: "ReviewedBy",
					HeaderLabel: strings.ApprovedBy,
					isReview: true,
				},
				{
					Name: "ReviewTimeStamp",
					DataProperty: "ReviewTimeStamp",
					HeaderLabel: strings.ApprovedOn,
					isReview: true,
					isDate: true,
					isLocal: true,
				},
				{
					Name: "ReviewComment",
					DataProperty: "Comment",
					HeaderLabel: strings.Comment,
					isReview: true,
				},
				{
					Name: "DeviceID",
					DataProperty: "DeviceID",
					HeaderLabel: strings.DeviceId,
					isLCS: true,
				},
				{
					Name: "PhysicianName",
					DataProperty: "PhysicianName",
					HeaderLabel: strings.Physician,
					isLCS: true,
				},
				{
					Name: "CaseName",
					DataProperty: "CaseName",
					HeaderLabel: strings.CaseId,
					isLCS: true,
				},
				{
					Name: "ProcedureName",
					DataProperty: "ProcedureName",
					HeaderLabel: strings.ProcedureId,
					isLCS: true,
				},

				{
					Name: "STSLotNumber",
					DataProperty: "STSLotNumber",
					HeaderLabel: strings.STSLotNumber,
					isReview: true,
				},
				{
					Name: "STSResultIcon",
					DataProperty: "STSResultIcon",
					HeaderLabel: strings.STSResult,
					isReview: true,
					isCustomRendering: true,
				},
				{
					Name: "MonitoringStatus",
					DataProperty: "MonitoringStatus",
					HeaderLabel: strings.ProcessMonitoring,
					isReview: true,
				},
				{
					Name: "LCSCILotNumber",
					DataProperty: "LCSCILotNumber",
					HeaderLabel: strings.CILotNumber,
					isReview: true,
				},
				{
					Name: "LCSCIResultIcon",
					DataProperty: "LCSCIResultIcon",
					HeaderLabel: strings.CIResult,
					isReview: true,
					isCustomRendering: true,
				},
			],
			System1ETopSection: [
				{
					Name: "LocationName",
					DataProperty: "LocationName",
					HeaderLabel: strings.LocationName,
					isEquipment: true,
				},
				{
					Name: "DeviceType",
					DataProperty: "DeviceType",
					HeaderLabel: strings.DeviceType,
					isEquipment: true,
				},
				{
					Name: "EquipmentName",
					DataProperty: "EquipmentName",
					HeaderLabel: strings.EquipmentId,
					isEquipment: true,
				},
				{
					Name: "ModelName",
					DataProperty: "ModelName",
					HeaderLabel: strings.EquipmentModel,
					isEquipment: true,
				},
				{
					Name: "SerialNumber",
					DataProperty: "SerialNumber",
					HeaderLabel: strings.SerialNumber,
					isEquipment: true,
				},
				{
					Name: "CycleCount",
					DataProperty: "CycleCount",
					HeaderLabel: strings.CycleCount,
					isCycle: true,
				},
				{
					Name: "CycleStart",
					DataProperty: "CycleStart",
					HeaderLabel: strings.TimeDate,
					isCycle: true,
					isDate: true,
				},
				{
					Name: "CycleStatus",
					DataProperty: "CycleStatus",
					HeaderLabel: strings.CycleStatus,
					isCycle: true,
				},
				{
					Name: "CycleName",
					DataProperty: "CycleName",
					HeaderLabel: strings.CycleName,
					isCycle: true,
				},
				{
					Name: "CycleComplete",
					DataProperty: "CycleEnd",
					HeaderLabel: strings.CycleComplete,
					isCycle: true,
					isDate: true,
				},
				{
					Name: "MaxPureFilterTest",
					DataProperty: "FilterTestStatus",
					HeaderLabel: strings.MaxPureFilterTest,
					isCycle: true,
				},
				{
					Name: "OperatorName",
					DataProperty: "OperatorName",
					HeaderLabel: strings.LoadOperator,
					isCycle: true,
				},
				{
					Name: "UnloadOperatorName",
					DataProperty: "UnloadOperatorName",
					HeaderLabel: strings.UnloadOperator,
					isCycle: true,
				},
				{
					Name: "ChamberOpenedTime",
					DataProperty: "ChamberOpenedTime",
					HeaderLabel: strings.ChamberOpened,
					isCycle: true,
					isDate: true,
				},
				{
					Name: "CycleDuration",
					DataProperty: "CycleDuration",
					HeaderLabel: strings.CycleDuration,
					isCycle: true,
				},
				{
					Name: "ErrorDescription",
					DataProperty: "ErrorDescription",
					HeaderLabel: strings.AlarmDescription,
					isCycle: true,
				},
				{
					Name: "EndoScopeTop",
					HeaderLabel: strings.EndoScopeTop,
					index: 3,
				},
				{
					Name: "EndoscopeSerialNumberTop",
					DataProperty: "EndoscopeSerialNumberTop",
					HeaderLabel: strings.SNo,
					isEndoScopeTop: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeTopName",
					DataProperty: "EndoscopeTopName",
					HeaderLabel: strings.EndoName,
					isEndoScopeTop: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelTop",
					DataProperty: "EndoscopeModelTop",
					HeaderLabel: strings.EndoModel,
					isEndoScopeTop: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "TopOrderNumber",
					DataProperty: "ItemRefNumberTop",
					HeaderLabel: strings.EndoON,
					isEndoScopeTop: true,
					valueRequired: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeSerialNumberTop",
					DataProperty: "EndoscopeSerialNumberTop",
					HeaderLabel: strings.SNo,
					isEndoScopeTop: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeTopName",
					DataProperty: "EndoscopeTopName",
					HeaderLabel: strings.EndoName,
					isEndoScopeTop: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelTop",
					DataProperty: "EndoscopeModelTop",
					HeaderLabel: strings.EndoModel,
					isEndoScopeTop: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "TopOrderNumber",
					DataProperty: "ItemRefNumberTop",
					HeaderLabel: strings.EndoON,
					isEndoScopeTop: true,
					valueRequired: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeSerialNumberTop",
					DataProperty: "EndoscopeSerialNumberTop",
					HeaderLabel: strings.SNo,
					isEndoScopeTop: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "EndoscopeTopName",
					DataProperty: "EndoscopeTopName",
					HeaderLabel: strings.EndoName,
					isEndoScopeTop: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelTop",
					DataProperty: "EndoscopeModelTop",
					HeaderLabel: strings.EndoModel,
					isEndoScopeTop: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "TopOrderNumber",
					DataProperty: "ItemRefNumberTop",
					HeaderLabel: strings.EndoON,
					isEndoScopeTop: true,
					valueRequired: true,
					index: 2,
					isEnspire: false,
				},
				{ Name: "EndoScopeBottom", HeaderLabel: strings.EndoScopeBottom, index: 3 },
				{
					Name: "EndoscopeSerialNumberBottom",
					DataProperty: "EndoscopeSerialNumberBottom",
					HeaderLabel: strings.SNo,
					isEndoScopeBottom: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeBottomName",
					DataProperty: "EndoscopeBottomName",
					HeaderLabel: strings.EndoName,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelBottom",
					DataProperty: "EndoscopeModelBottom",
					HeaderLabel: strings.EndoModel,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "BottomOrderNumber",
					DataProperty: "ItemRefNumberBottom",
					HeaderLabel: strings.EndoON,
					isAccess: true,
					isEndoScopeBottom: true,
					valueRequired: true,
					index: 0,
					isEnspire: false,
				},
				{
					Name: "EndoscopeSerialNumberBottom",
					DataProperty: "EndoscopeSerialNumberBottom",
					HeaderLabel: strings.SNo,
					isEndoScopeBottom: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeBottomName",
					DataProperty: "EndoscopeBottomName",
					HeaderLabel: strings.EndoName,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelBottom",
					DataProperty: "EndoscopeModelBottom",
					HeaderLabel: strings.EndoModel,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "BottomOrderNumber",
					DataProperty: "ItemRefNumberBottom",
					HeaderLabel: strings.EndoON,
					isAccess: true,
					isEndoScopeBottom: true,
					valueRequired: true,
					index: 1,
					isEnspire: false,
				},
				{
					Name: "EndoscopeSerialNumberBottom",
					DataProperty: "EndoscopeSerialNumberBottom",
					HeaderLabel: strings.SNo,
					isEndoScopeBottom: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "EndoscopeBottomName",
					DataProperty: "EndoscopeBottomName",
					HeaderLabel: strings.EndoName,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "EndoscopeModelBottom",
					DataProperty: "EndoscopeModelBottom",
					HeaderLabel: strings.EndoModel,
					isAccess: true,
					isEndoScopeBottom: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "BottomOrderNumber",
					DataProperty: "ItemRefNumberBottom",
					HeaderLabel: strings.EndoON,
					isAccess: true,
					isEndoScopeBottom: true,
					valueRequired: true,
					index: 2,
					isEnspire: false,
				},
				{
					Name: "InstrumentNumber",
					DataProperty: "InstrumentNumber",
					HeaderLabel: "",
					isEnspire: true,
				},
				{
					Name: "InstrumentSN",
					DataProperty: "InstrumentSN",
					HeaderLabel: strings.DeviceSerial,
					isEnspire: true,
				},
				{
					Name: "InstrumentName",
					DataProperty: "InstrumentName",
					HeaderLabel: strings.DeviceId,
					isEnspire: true,
				},
				{
					Name: "ModelNumber",
					DataProperty: "ModelNumber",
					HeaderLabel: strings.DeviceModel,
					isEnspire: true,
				},
				{
					Name: "CaseID",
					DataProperty: "CaseID",
					HeaderLabel: strings.CaseId,
					isEnspire: true,
				},
				{
					Name: "ProcedureID",
					DataProperty: "ProcedureID",
					HeaderLabel: strings.ProcedureId,
					isEnspire: true,
				},
				{
					Name: "PhysicianID",
					DataProperty: "PhysicianID",
					HeaderLabel: strings.Physician,
					isEnspire: true,
				},
				{
					Name: "ReviewStatus",
					DataProperty: "ReviewStatus",
					HeaderLabel: strings.ReviewStatus,
					isReview: true,
				},
				{
					Name: "ReviewedBy",
					DataProperty: "ReviewedBy",
					HeaderLabel: strings.ApprovedBy,
					isReview: true,
				},
				{
					Name: "ReviewTimeStamp",
					DataProperty: "ReviewTimeStamp",
					HeaderLabel: strings.ApprovedOn,
					isReview: true,
					isDate: true,
					isLocal: true,
				},
				{
					Name: "ReviewComment",
					DataProperty: "Comment",
					HeaderLabel: strings.Comment,
					isReview: true,
				},
				{
					Name: "DeviceID",
					DataProperty: "DeviceID",
					HeaderLabel: strings.DeviceId,
					isLCS: true,
				},
				{
					Name: "PhysicianName",
					DataProperty: "PhysicianName",
					HeaderLabel: strings.Physician,
					isLCS: true,
				},
				{
					Name: "CaseName",
					DataProperty: "CaseName",
					HeaderLabel: strings.CaseId,
					isLCS: true,
				},
				{
					Name: "ProcedureName",
					DataProperty: "ProcedureName",
					HeaderLabel: strings.ProcedureId,
					isLCS: true,
				},

				{
					Name: "STSLotNumber",
					DataProperty: "STSLotNumber",
					HeaderLabel: strings.STSLotNumber,
					isReview: true,
				},
				{
					Name: "STSResultIcon",
					DataProperty: "STSResultIcon",
					HeaderLabel: strings.STSResult,
					isReview: true,
					isCustomRendering: true,
				},
				{
					Name: "MonitoringStatus",
					DataProperty: "MonitoringStatus",
					HeaderLabel: strings.ProcessMonitoring,
					isReview: true,
				},
				{
					Name: "LCSCILotNumber",
					DataProperty: "LCSCILotNumber",
					HeaderLabel: strings.CILotNumber,
					isReview: true,
				},
				{
					Name: "LCSCIResultIcon",
					DataProperty: "LCSCIResultIcon",
					HeaderLabel: strings.CIResult,
					isReview: true,
					isCustomRendering: true,
				},
			],
		});
	}
	filterPrintData(prop, filterData) {
		const toReturn = [], me = this;
		this[prop].forEach(function (obj) {
			if (me[filterData].includes(obj.Name)) {
				toReturn.push(obj);
			}
		});
		return toReturn;
	}

	replaceDisplayName(prop, filterPropName, newString) {
		this[prop] = this[prop].map(function (obj) {
			return filterPropName === obj.Name ? Object.assign(obj, { HeaderLabel: newString }) : obj;
		});

	}
}

export default PrintProperties;